export default __webpack_public_path__ + "static/media/hero-ipad.05f873a3.png";